import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";

@Component({
    selector: 'esearch-clear-results',
    templateUrl: './e-search-clear-results.component.html',
    styleUrls: ['./e-search-clear-results.component.scss'],
    standalone: false
})
export class ESearchClearResultsComponent implements OnInit{
    paramsExists: boolean = false;
    constructor(protected router: Router,
                protected route: ActivatedRoute) {}

    ngOnInit() {
        this.route.queryParams.subscribe(params => {
            this.paramsExists = params ? true : false;
        });
    }

    clear() {
        this.router.navigate([], { queryParams: {} });
    }

}
